<template>
  <div class="section-small bg-color-primary">
    <div class="container">
      <div
        class="marquee heading--0 fw-light text-uppercase text-color-quinary margin-bottom-6-lg margin-bottom-5"
      >
        <p>BMW / ROLLS-ROYCE / PORSCHE / MERCEDES - BENZ / FERRARI / LAMBORGHINI / MCLAREN</p>
      </div>
      <a href="/" class="d-block text-center">
        <img src="/frontend/assets/svg/logo.svg" alt="Logo" />
      </a>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.marquee {
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}

.marquee p {
  display: inline-block;
  animation: marquee 15s linear infinite;
}
</style>
